module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGF02-f7416113095f00b7cb21324c7bea2cca.png";